import { saveRowKeys } from 'Slices/Kiosk/ArticleSlice'
import {
  configurationAvailabilitiesFilter,
  configurationQuantitiesFilter,
  configurationActiveFilters,
  ExistingStock,
  UiCodeEnableMovementLog,
  UiCodeShowMovementPrice,
  configurationEmptyTableOptions,
  ConfigurationForm,
  ProfilesKeys,
  PricelistTypeFilter,
} from '../Constants/Configuration'
import { decrypt, encrypt, generatePassPhrase } from './EncoderHelper'
import { generateWorkspaceName, isFixedWorkspace } from './GenericHelpers'
import { setCapitalLetter, setLowerCaseLetter } from './StringHelpers'
import { WorkSpace } from 'Constants/WorkSpace'
import { TypeOfChannel } from 'Slices/Omnichannel/DiscountSlice'

//PUBLIC
const mapWorkspaceTableColFilters = (
  configurationName: string,
  defaultProfileOptions: any,
  tableColumnFilters: any,
  user: string,
  serverConfig: string,
) => {
  const activeFilters = decryptLocalStorageValue(configurationName + configurationActiveFilters, user, serverConfig)

  const tableColfilterCopy = JSON.parse(JSON.stringify(tableColumnFilters))

  for (var filterCategory in tableColfilterCopy) {
    tableColfilterCopy[filterCategory].forEach(filter => {
      const filterValue = filter.value

      if (defaultProfileOptions.length > 0) {
        const optionValue = defaultProfileOptions.find(option => setCapitalLetter(filterValue) === option.uiCode)
        if (optionValue) {
          filter.active = activeFilters ? activeFilters.indexOf(filterValue) !== -1 : optionValue.default
          filter.visible = optionValue.active
        }
      } else {
        if (activeFilters) {
          filter.active = activeFilters.indexOf(filterValue) !== -1
        }
      }
    })
  }

  return tableColfilterCopy
}

const mapWorkspaceEmptyTableColumn = (
  configurationName: string,
  emptyColumnFilter: any,
  user: string,
  serverConfig: string,
) => {
  const emptyFilters = decryptLocalStorageValue(configurationName + configurationEmptyTableOptions, user, serverConfig)

  const emptyFilterCopy = JSON.parse(JSON.stringify(emptyColumnFilter))

  if (emptyFilters && emptyFilters.length > 0) {
    for (var filterCategory in emptyFilterCopy) {
      emptyFilterCopy[filterCategory].forEach(filter => {
        const filterValue = filter.value
        filter.active = emptyFilters.indexOf(filterValue) !== -1
      })
    }
  }

  return emptyFilterCopy
}

const mapWorkspaceQuantitiesFilter = (
  configurationName: string,
  defaultProfileOptions: any,
  quantitiesFilters: any,
  user: string,
  serverConfig: string,
) => {
  const filterSaved = decryptLocalStorageValue(configurationName + configurationQuantitiesFilter, user, serverConfig)

  const quantitiesFilterCopy = JSON.parse(JSON.stringify(quantitiesFilters))

  quantitiesFilterCopy.forEach(filter => {
    if (filter.value !== ExistingStock) {
      if (defaultProfileOptions.length > 0) {
        const optionValue = defaultProfileOptions.find(option => option.uiCode === setCapitalLetter(filter.value))
        if (optionValue) {
          filter.active = filterSaved ? filterSaved.indexOf(filter.value) !== -1 : optionValue.default
          filter.visible = optionValue.active
        }
      } else {
        if (filterSaved) {
          filter.active = filterSaved.indexOf(filter.value) !== -1
        }
      }
    } else {
      filter.visible = true
    }
  })

  return quantitiesFilterCopy
}

const mapAvailabilitiesFilter = (
  configurationName: string,
  defaultProfileOptions: any,
  avialabilitiesFilter: any,
  user: string,
  serverConfig: string,
) => {
  const filterSaved = decryptLocalStorageValue(
    configurationName + configurationAvailabilitiesFilter,
    user,
    serverConfig,
  )

  const availabilitiesFilterCopy = JSON.parse(JSON.stringify(avialabilitiesFilter))
  const optionValue = defaultProfileOptions.filter(option => option.uiCode === UiCodeEnableMovementLog)

  availabilitiesFilterCopy.forEach(filter => {
    if (defaultProfileOptions.length > 0) {
      if (optionValue && optionValue.length > 0) {
        filter.active = filterSaved ? filterSaved.indexOf(filter.value) !== -1 : optionValue[0].default
        filter.visible = optionValue[0].active
      }
    } else {
      if (filterSaved) {
        filter.active = filterSaved.indexOf(filter.value) !== -1
      }
    }
  })

  return availabilitiesFilterCopy
}

const checkArticleTableStorageValuesAndPushMissingFilters = (
  storedValues: any,
  defaultFilterValues: any,
  filterGroup: any,
  sorting = [],
) => {
  if (storedValues && storedValues[filterGroup].length !== 0) {
    defaultFilterValues.forEach(option => {
      const isOptionInFilter = storedValues[filterGroup].filter(filter => {
        return setCapitalLetter(filter.value) === option.uiCode
      })

      if (isOptionInFilter.length === 0) {
        storedValues[filterGroup].push({
          value: setLowerCaseLetter(option.uiCode),
          active: option.default,
          visible: option.active,
        })
      }
    })

    storedValues[filterGroup].forEach((filter, index, self) => {
      const isFilterInOption = defaultFilterValues.filter(option => {
        return setCapitalLetter(filter.value) === option.uiCode
      })

      if (isFilterInOption.length === 0) {
        filter.visible = false
      }
    })

    if (sorting.length !== 0) {
      storedValues[filterGroup].sort((a, b) => sorting.indexOf(a.value) - sorting.indexOf(b.value))
    }
  }
}

const checkArticleDetailStorageValuesAndPushMissingFilters = (storedValues: any, defaultFilterValues: any) => {
  defaultFilterValues.forEach(option => {
    const isOptionInFilter = storedValues.find(filter => {
      return setCapitalLetter(filter) === option.uiCode && option.uiCode !== UiCodeShowMovementPrice
    })

    if (!isOptionInFilter) {
      if (option.default) {
        storedValues.push(setLowerCaseLetter(option.uiCode))
      }
    }
  })
}

const mapDefaultPriceListFilters = (priceListsObject: any, defaultPriceList1?: string) => {
  priceListsObject['priceList1Visible'] = true
  priceListsObject['priceList1Enabled'] = true
  priceListsObject['priceList1'] = defaultPriceList1 ? defaultPriceList1 : ''
  priceListsObject['priceList2Visible'] = true
  priceListsObject['priceList2Enabled'] = false
  priceListsObject['priceList2'] = ''

  return priceListsObject
}

const checkLocalStorageWorkspaceElementVisibility = (hiddenElements: any, element: string) => {
  return !hiddenElements || hiddenElements.indexOf(element) === -1
}

const setStorageValue = (localStorageKey: string, userValue: string, serverConfig: string, value: string) => {
  const storageKey = generateWorkspaceName(localStorageKey, userValue, serverConfig)
  localStorage.setItem(storageKey, value)
}

const getStorageValue = (localStorageKey: string, userValue: string, serverConfig: string) => {
  const storageKey = generateWorkspaceName(localStorageKey, userValue, serverConfig)
  return localStorage.getItem(storageKey)
}

const removeStorageValue = (localStorageKey: string, userValue: string, serverConfig: string) => {
  const storageKey = generateWorkspaceName(localStorageKey, userValue, serverConfig)
  return localStorage.removeItem(storageKey)
}

const encryptLocalStorageValue = (localStorageKey: string, value: string, user: string, serverConfig: string) => {
  const encryptedValue = encrypt(value, generatePassPhrase(serverConfig, user))

  setStorageValue(localStorageKey, user, serverConfig, encryptedValue)
}

const decryptLocalStorageValue = (localStorageKey: string, user: string, serverConfig: string) => {
  const value = getStorageValue(localStorageKey, user, serverConfig)

  return decrypt(value, generatePassPhrase(serverConfig, user))
}

const getConfigurationList = (
  profileValue: number,
  publicWorkspace: string,
  userValue: string,
  serverConfig: string,
  profileWorkspaces: string[],
) => {
  const configurations = []
  Object.keys(localStorage).forEach(element => {
    const splitName = element.split('_')
    const workspace = splitName[0]
    const storedUserValue = splitName[2]
    const storedConfig = splitName[3]

    if (
      splitName.length === 4 &&
      workspace &&
      configurations.indexOf(workspace) === -1 &&
      workspace?.toUpperCase() !== ConfigurationForm.GRUCCIA &&
      storedUserValue === userValue &&
      storedConfig === serverConfig &&
      (!publicWorkspace ||
        profileValue === ProfilesKeys.SuperProfile ||
        !isFixedWorkspace(splitName[0]) ||
        workspace === publicWorkspace ||
        (publicWorkspace && profileWorkspaces && profileWorkspaces.indexOf(workspace) > -1))
    ) {
      configurations.push(splitName[0])
    }
  })

  return configurations
}

const rowKeysSet = (vaId: any) => (dispatch, getState) => {
  const state = getState()
  const formConfigurationValue = state.present.configuration.formConfigurationValue

  dispatch(
    saveRowKeys({
      rowKeys: [vaId],
      formValue: formConfigurationValue,
    }),
  )
}

//To add: PIM, to exlude: DEFAULT

const checkPIMVisibility = (value: WorkSpace) => {
  const includedWorkspaces = [
    WorkSpace.MARKETPLACE,
    WorkSpace.WEB,
    WorkSpace.OMNICHANNEL,
    WorkSpace.BACKOFFICE,
    WorkSpace.PIM,
    WorkSpace.DEFAULT,
    WorkSpace.B2B,
  ]
  return includedWorkspaces.includes(value)
}

const checkWorkspaceSitesVisibility = (value: WorkSpace) => {
  const excludedWorkspaces = [WorkSpace.MARKETPLACE, WorkSpace.STOREMANAGER, WorkSpace.STORE]
  return !excludedWorkspaces.includes(value)
}

const checkWorkspaceStoresVisibility = (value: WorkSpace) => {
  const excludedWorkspaces = [WorkSpace.MARKETPLACE, WorkSpace.WEB, WorkSpace.PIM, WorkSpace.OMNICHANNEL]
  return !excludedWorkspaces.includes(value)
}

const checkWorkspaceMarketplaceVisibility = (value: WorkSpace) => {
  const excludedWorkspaces = [WorkSpace.STOREMANAGER, WorkSpace.WEB, WorkSpace.PIM, WorkSpace.STORE]
  return !excludedWorkspaces.includes(value)
}

const checkOmnichannelAndPricesVisibility = (value: WorkSpace) => {
  const excludedWorkspaces = []
  return !excludedWorkspaces.includes(value)
}

const checkSettingsVisibility = (value: any) => {
  const includedWorkspaces = [WorkSpace.BACKOFFICE]
  return includedWorkspaces.includes(value)
}

const checkDefaultTypeOfChannel = (value: string) => {
  switch (value) {
    case WorkSpace.WEB:
    case WorkSpace.PIM:
      return TypeOfChannel.Site.toString()
    case WorkSpace.STOREMANAGER:
    case WorkSpace.STORE:
      return TypeOfChannel.Store.toString()
    default:
      return TypeOfChannel.Marketplace.toString()
  }
}

const checkPricesSingleTab = (value: WorkSpace) => {
  const includedWorkspaces = [
    WorkSpace.STOREMANAGER,
    WorkSpace.WEB,
    WorkSpace.MARKETPLACE,
    WorkSpace.PIM,
    WorkSpace.STORE,
  ]
  return includedWorkspaces.includes(value)
}

const checkOmniPricesSingleTab = (value: WorkSpace) => {
  const includedWorkspaces = [WorkSpace.WEB, WorkSpace.MARKETPLACE, WorkSpace.B2B]
  return includedWorkspaces.includes(value)
}

const checkPricelistTypeFilter = (value: WorkSpace) => {
  const B2B = [WorkSpace.B2B]
  //empty because at the moment there are no B2C-only workspaces
  const B2C = []

  if (B2B.includes(value)) {
    return PricelistTypeFilter.B2B
  }

  if (B2C.includes(value)) {
    return PricelistTypeFilter.B2C
  }

  return PricelistTypeFilter.ALL
}

const isOmniVisible = (value: WorkSpace) => {
  const excludedWorkspaces = [WorkSpace.STORE, WorkSpace.STOREMANAGER, WorkSpace.PIM]
  return !excludedWorkspaces.includes(value)
}

export {
  mapWorkspaceTableColFilters,
  mapWorkspaceQuantitiesFilter,
  checkArticleTableStorageValuesAndPushMissingFilters,
  checkArticleDetailStorageValuesAndPushMissingFilters,
  mapAvailabilitiesFilter,
  mapDefaultPriceListFilters,
  mapWorkspaceEmptyTableColumn,
  checkLocalStorageWorkspaceElementVisibility,
  encryptLocalStorageValue,
  decryptLocalStorageValue,
  setStorageValue,
  getStorageValue,
  removeStorageValue,
  getConfigurationList,
  rowKeysSet,
  checkPIMVisibility,
  checkWorkspaceSitesVisibility,
  checkWorkspaceStoresVisibility,
  checkWorkspaceMarketplaceVisibility,
  checkOmnichannelAndPricesVisibility,
  checkSettingsVisibility,
  checkDefaultTypeOfChannel,
  checkPricesSingleTab,
  checkOmniPricesSingleTab,
  checkPricelistTypeFilter,
  isOmniVisible,
}
